import moment from "moment";
import { getSQLOperatorByFilterOption } from "../../../../utils/tableUtils";

const FIELD_TO_SNAKE = {
  handlingNumber: "handling_number",
  tagId: "tag_id",
  farmStatus: "farm_status",
  lotName: "lot_name",
  picketName: "picket_name",
  breedName: "breed_name",
  nickname: "nickname",
  sisbov: "sisbov",
  gender: "gender",
  lastDailyWeight: "last_daily_weight",
  lastDailyWeightGain: "last_daily_weight_gain",
  lastDailyWeightDate: "last_daily_weight_date",
  acquisitionDate: "acquisition_date",
  supplierName: "supplier_name",
};

function getFieldSnake(k) {
  return FIELD_TO_SNAKE[k] || k;
}

function buildAnimalSearchString(filters, baseSearch) {
  const hasFilters = filters && Object.entries(filters).length > 0;
  let search = baseSearch;

  if (hasFilters) {
    Object.entries(filters).forEach(([k, v]) => {
      if (v == null) return;
      const isArray = Array.isArray(v);
      const isObject = v && typeof v === "object" && !Array.isArray(v);
      const hasValue = isArray
        ? v.length > 0
        : isObject
          ? Object.keys(v).length > 0
          : true;
      if (!hasValue) return;

      const fieldS = getFieldSnake(k);

      if (
        fieldS === "last_daily_weight" ||
        fieldS === "last_daily_weight_gain"
      ) {
        let operator = v[1] ?? "equal";
        operator = getSQLOperatorByFilterOption(operator)
          .replace("<", "%3C")
          .replace(">", "%3E");
        const val = operator !== "between" ? v[0] : [v[0], v[2]];
        const part =
          operator === "BETWEEN"
            ? `${fieldS} between '${val[0]}' and '${val[1]}'`
            : `${fieldS} ${operator} ${parseFloat(v[0])}`;
        search = search ? `${search};${part}` : part;
        return;
      }

      if (
        fieldS === "last_daily_weight_date" ||
        fieldS === "acquisition_date"
      ) {
        let operator = v[1] ?? "equal";
        const dateVal =
          operator !== "between"
            ? moment(v[0]).format("YYYY-MM-DD")
            : operator === "between"
              ? [
                  moment(v[0]).format("YYYY-MM-DD"),
                  moment(v[2]).format("YYYY-MM-DD"),
                ]
              : moment(v[0]).format("YYYY-MM-DD");
        operator = getSQLOperatorByFilterOption(operator)
          .replace("<", "%3C")
          .replace(">", "%3E");

        const part =
          operator === "BETWEEN"
            ? `${fieldS} between '${dateVal[0]}' and '${dateVal[1]}'`
            : `${fieldS} ${operator} '${dateVal}'`;
        search = search ? `${search};${part}` : part;
        return;
      }

      if (fieldS === "gender") {
        const list = isArray ? v : [v];
        const part = `${fieldS} in (${list.map((o) => `'${o}'`).join(", ")})`;
        search = search ? `${search};${part}` : part;
        return;
      }

      if (fieldS === "sisbov") {
        const str = isArray ? v[0] : isObject ? v.value : v;
        const part = `upper(cast(${fieldS} as varchar)) like upper('%25${str}%25')`;
        search = search ? `${search};${part}` : part;
        return;
      }

      const str = isArray ? v[0] : isObject ? v.value : String(v);
      const part = `upper(${fieldS}) like upper('%25${str}%25')`;
      search = search ? `${search};${part}` : part;
    });
  }

  return search;
}

export function getAnimalSearchString(filters) {
  return buildAnimalSearchString(
    filters,
    "farm_status='A';boitel_contract_id is null",
  );
}

export function getContractAnimalSearchString(contractId, filters) {
  return buildAnimalSearchString(
    filters,
    `boitel_contract_id = '${contractId}'`,
  );
}

export function getAnimalSortField(sorter) {
  if (!sorter || !sorter.columnKey) return null;
  const fieldMap = {
    handlingNumber: "handling_number",
    tagId: "tag_id",
    nickname: "nickname",
    sisbov: "sisbov",
    farmStatus: "farm_status",
    picketName: "picket_name",
    lotName: "lot_name",
    breedName: "breed_name",
    gender: "gender",
    lastDailyWeight: "last_daily_weight",
    lastDailyWeightGain: "last_daily_weight_gain",
    lastDailyWeightDate: "last_daily_weight_date",
    acquisitionDate: "acquisition_date",
    supplierName: "supplier_name",
  };
  return fieldMap[sorter.columnKey] || sorter.columnKey;
}
